$( document ).ready(function() {
  $("#mini-cart").hide();

  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  $( window ).on( "resize", function() {
    // HEIGHT VIEWPORT
    const windowHeight = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  });

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  $(document).on('click',  '#composition-trigger', function(){
    $("#details-content, #details-trigger, #shipping-content, #shipping-returns-trigger").removeClass("active");
    $(".info-trigger").removeClass("active");
    $("#composition-content, #composition-trigger").addClass("active");
    $(this).addClass("active");
  });  
  $(document).on('click',  '#details-trigger', function(){
    $(".info-trigger").removeClass("active");
    $("#details-content, #details-trigger").addClass("active");
    $("#composition-content, #composition-trigger, #shipping-content, #shipping-returns-trigger").removeClass("active");
  });  
  $(document).on('click',  '#shipping-returns-trigger', function(){
    $("#details-content, #details-trigger, #composition-content, #composition-trigger").removeClass("active");
    $(".info-trigger").removeClass("active");
    $("#shipping-content, #shipping-returns-trigger").addClass("active");
    $(this).addClass("active");
  });  

  // HEIGHT SUBMENU
  var highest = 0;
  var shopLinks = $("#shop-container .collection-link").length;
  var newInLinks = $("#newin-container .collection-link").length;
  var collectionLinks = $("#collection-container .collection-link").length;
  if(shopLinks > highest){
    highest = shopLinks;
  }
  if(newInLinks > highest){
    highest = newInLinks;
  }
  if(collectionLinks > highest){
    highest = collectionLinks;
  }
  console.log("Highest: " + highest);
  var heightSubmenu = (highest * 21) + 10;
  $("#shop-container, #newin-container, #collection-container").css("height", heightSubmenu);

  // ADD/REMOVE ITEM
  setTimeout(function(){
    $(document).on('click',  '.plus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        incrementValue(e);
    });  
    $(document).on('click',  '.minus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        decrementValue(e);
    });  
  }, 20);
  // UPDATE CART COUNT
  function updateCartCount() {
    jQuery.getJSON('/cart.js', function(cart) {
      let itemscount = cart.item_count;
      var totalmoney = cart.total_price;
      totalmoney = totalmoney.toString().slice(0,-2);
      var len = totalmoney.length;
      var x = totalmoney.substring(0, len-3) + "," + totalmoney.substring(len-3);
      if(len < 4){
        $("#total-price-minicart").text(totalmoney + "€");
      } else {
        $("#total-price-minicart").text(x + "€");
      }
      if(itemscount == 0){
        $( "#cart-trigger" ).click();
        $("#cart-trigger").addClass("disabled");
      } else {
        $("#cart-trigger").removeClass("disabled");
      }
      $("#cart-trigger-number").text(itemscount);
      $("#mini-cart-title").text("Your cart (" + itemscount + ")");
    });
  }
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    var maxinv = $(e.target).data("inventory")
    console.log(maxinv);

    if(currentVal >= maxinv) {
      console.log("No more stock");
    } else {
      if (!isNaN(currentVal)) {
        parent.find('input[name="updates[]"]').val(currentVal + 1);
        parent.find('.quantity-wrap').text(currentVal + 1);
        jQuery.post('/cart/change.js', {
          quantity: currentVal + 1,
          id: id
        });
      } else {
        parent.find('input[name="updates[]"]').val(0);
        parent.find('.quantity-wrap').text(0);
        jQuery.post('/cart/change.js', {
          quantity: 0,
          id: id
        });
      }
    }
    
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var cartitem = $(e.target).closest(".mini-cart-item");
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    
    if (!isNaN(currentVal) && currentVal > 1) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
      parent.find('.quantity-wrap').text(currentVal - 1);
      jQuery.post('/cart/change.js', {
        quantity: currentVal - 1,
        id: id
      });
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find('.quantity-wrap').text(0);
      jQuery.post('/cart/change.js', {
        quantity: 0,
        id: id
      });
      cartitem.remove();
    }
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }

  // TOGGLE MINICART
  $( "#mini-cart-close-mobile" ).click(function() {
    $( "#mini-cart" ).removeClass("active").fadeOut(300);
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).removeClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
  });
  $( "#cart-trigger" ).click(function() {
    $( "#mini-cart" ).toggleClass("active").fadeToggle(300);
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).toggleClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
    $('#newin-container, #collection-container, #shop-container, #search-form, #about-container, #contact-container').slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  // FOOTER
  $( "#footer-credits-trigger" ).click(function() {
    $('#footer-credits').slideToggle(300);
  });
  
  // MENU
  $( ".footer-link[href='/pages/about'], #about-close" ).click(function() {
    event.preventDefault();
    $('#about-container').fadeToggle(300);
    $('#newin-container, #collection-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
    if($("body").is(".blackheader")){
      $("body").removeClass("blackheader");
    } else {
      $("body").addClass("blackheader");
    }
  });

  // SIZE GUIDE
  $( "#size-guide-trigger, #size-guide-trigger-mobile, #size-guide-close" ).click(function() {
    $('#size-guide-container').fadeToggle(300);
  });
  
  
  /*$("#shop-trigger").click(function() {
    $('#shop-container').slideToggle(300);
    $('#newin-container, #collection-container, #search-form, #contact-container').slideUp(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
  });*/
  /*var hoverTimeoutShop;
  $("#shop-trigger, #shop-container").hover(
    function() {
      clearTimeout(hoverTimeoutShop);
      $("#shop-container").slideDown(300);
      $('#newin-container, #collection-container, #search-form, #contact-container').slideUp(300);
      $("#mini-cart").removeClass("active").slideUp(300);
    },
    function() {
      hoverTimeoutShop = setTimeout(function() {
        $("#shop-container").slideUp(300);
      }, 200);
    }
  );*/
  
  $("#newin-trigger").click(function() {
    $('#newin-container').fadeToggle(300);
    $('#shop-container, #collection-container, #search-form, #contact-container').fadeOut(300);
    $( "#mini-cart" ).removeClass("active").fadeOut(300);
    if($("body").is(".blackheader")){
      $("body").removeClass("blackheader");
    } else {
      $("body").addClass("blackheader");
    }
  });
  /*var hoverTimeoutNewIn;
  $("#newin-trigger, #newin-container").hover(
    function() {
      clearTimeout(hoverTimeoutNewIn);
      $("#newin-container").slideDown(300);
      $('#shop-container, #collection-container, #search-form, #contact-container').slideUp(300);
      $("#mini-cart").removeClass("active").slideUp(300);
    },
    function() {
      hoverTimeoutNewIn = setTimeout(function() {
        $("#newin-container").slideUp(300);
      }, 200);
    }
  );*/
   
  $("#search-trigger").click(function() {
    $('#search-form').fadeToggle(300);
    $('#newin-container, #collection-container, #shop-container, #contact-container').fadeOut(300);
    $( "#mini-cart" ).removeClass("active").fadeOut(300);
    setTimeout(function(){
      $("input.search-input-text").focus();
    }, 400);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
    if($("body").is(".blackheader")){
      $("body").removeClass("blackheader");
    } else {
      $("body").addClass("blackheader");
    }
  });
  var hoverTimeoutSearch;
  /*$("#search-trigger, #search-form").hover(
    function() {
      clearTimeout(hoverTimeoutSearch);
      $('#search-form').slideDown(300);
      $('#newin-container, #collection-container, #shop-container, #contact-container').slideUp(300);
      $( "#mini-cart" ).removeClass("active").slideUp(300);
      setTimeout(function(){
        $("input.search-input-text").focus();
      }, 400);
    },
    function() {
      hoverTimeoutSearch = setTimeout(function() {
        $("#search-form").slideUp(300);
      }, 200);
    }
  );*/
  $("#search-close").click(function() {
    $('#search-form').fadeOut(300);
    $("body").removeClass("blackheader");
  });
  
  // MENU MOBILE
  $( "#burger" ).click(function() {
    $("body").toggleClass("black-menu");
    $('#menu-mobile').toggleClass('show');
    $(this).toggleClass("active");
    $( "#mini-cart" ).removeClass("active");
  });

  $( ".collection-link" ).hover(
    function() {
      var img = $(this).attr("data-img")
      if(img != ""){
        console.log("Contiene", img);
        $("<div class='hover-image-menu'><img src='" + img + "'></div>").appendTo( $(this).parent() );
      }
    }, function() {
      $(".hover-image-menu").remove();
    }
  );

  /*$('.footer-link[href="/pages/about"], #about-trigger-mobile').click(function() {
    event.preventDefault();
    $("#about-container").slideDown(300);
    $('#newin-container, #collection-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $("#mini-cart").removeClass("active").slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });*/
  
  $('.footer-link[href="/pages/contact"], #contact-close').click(function() {
    event.preventDefault();
    $('#newin-container, #collection-container, #shop-container, #search-form, #about-container').slideUp(300);
    $('#contact-container').fadeToggle(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
    if($("body").is(".blackheader")){
      $("body").removeClass("blackheader");
    } else {
      $("body").addClass("blackheader");
    }
  });

  // MENU MOBILE
  $("#menu-trigger-mobile").click(function() {
    $(this).children("span").toggle();
    $("#menu-mobile").slideToggle().toggleClass("active");
  });
  
  // HIGHLIGHT CHANGE IMAGE MOBILE
  $(".homepage-highlight-image").click(function() {
    event.preventDefault();
    var windowWidth = $(window).width(),
        href = $(this).parent().parent('.homepage-highlight-link').attr('href'),
        el = $(this),
        src = el.attr("src");
    if(windowWidth <= 820){
      el.parent().parent().parent().children(".homepage-highlight-mobile").children(".highlight-module").children(".homepage-highlight-image").attr("src", src);
    } else {
      window.location.href = href;
    }
  });

  const featuredSwiper = new Swiper('.featured-swiper', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: "auto",
    spaceBetween: 15,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 5,
      thresholdDelta: 25,
      thresholdTime: 25
    },
  });
});



















